import {ConfigTypeFromFetchFunction, FetchFunction} from '../types'
import {addHeaders} from '../utils'

type Idempotent = {
  idempotent?: boolean
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function withIdempotency<TReq = unknown, TRes = unknown, TExtraConfig extends Record<string, unknown> = {}>(
  fetchFunc: FetchFunction<TReq, TRes, TExtraConfig>,
) {
  return function enhancedFetch(config: ConfigTypeFromFetchFunction<typeof fetchFunc> & Idempotent) {
    let headers: Record<string, string> = {}

    if (config.idempotent) {
      headers['X-Idempotency-Token'] = uuidv4()
    }

    return fetchFunc(addHeaders(config, headers))
  }
}
